import { contact } from 'assets/js/data';
import Paragraph from 'common/Paragraph';

const TextContact = () => <Paragraph>{contact.text}</Paragraph>;

export default TextContact;
